<template>
  <div class="container">
    <h2 class="mt-4">{{ $t('manage_users_in_group') }}: {{ group.name }}</h2>

    <!-- Success and Error Messages -->
    <div v-if="successMessage" class="alert alert-success alert-dismissible fade show fixed-alert" role="alert">
      {{ successMessage }}
      <button type="button" class="btn-close" @click="successMessage = ''"></button>
    </div>
    <div v-if="errorMessage" class="alert alert-danger alert-dismissible fade show fixed-alert" role="alert">
      {{ errorMessage }}
      <button type="button" class="btn-close" @click="errorMessage = ''"></button>
    </div>

    <!-- User List -->
    <div class="mb-4">
      <h3>{{ $t('select_users') }}</h3>
      <div v-for="user in users" :key="user.id" class="form-check">
        <input
            class="form-check-input"
            type="checkbox"
            :id="'user-' + user.id"
            :value="user.id"
            v-model="selectedUsers"
        />
        <label class="form-check-label" :for="'user-' + user.id">
          {{ user.first_name }} {{ user.last_name }} ({{ user.username }})
        </label>
      </div>
    </div>

    <button class="btn btn-primary" @click="submitUsers('add')">{{ $t('add_selected_users') }}</button>
    <button class="btn btn-danger ms-2" @click="submitUsers('remove')">{{ $t('remove_selected_users') }}</button>
    <router-link to="/groups" class="btn btn-secondary ms-2">{{ $t('cancel') }}</router-link>
  </div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'GroupManageUsers',
  data() {
    return {
      group: {},
      users: [],
      selectedUsers: [], // Stores the IDs of selected users
      successMessage: '',
      errorMessage: ''
    };
  },
  mounted() {
    this.getGroup();
    this.getUsers();
    this.getGroupUsers();
  },
  methods: {
    async getGroup() {
      try {
        const response = await axios.get(`/api/v1/admin/groups/${this.$route.params.id}/`);
        this.group = response.data;
      } catch (error) {
        this.errorMessage = 'Failed to fetch group details';
      }
    },
    async getUsers() {
      try {
        let url = '/api/v1/admin/users/?page=1';
        const allUsers = [];

        while (url) {
          const response = await axios.get(url);
          const data = response.data;

          allUsers.push(...(data.results || []));

          // DRF "next" may be absolute (and may incorrectly be http).
          // Convert it to a relative URL to guarantee same-origin HTTPS requests.
          if (data.next) {
            const nextUrl = new URL(data.next, window.location.origin);
            url = nextUrl.pathname + nextUrl.search;
          } else {
            url = null;
          }
        }

        this.users = allUsers;
      } catch (error) {
        this.errorMessage = 'Failed to fetch users';
        setTimeout(() => (this.errorMessage = ''), 3000);
      }
    },
    async getGroupUsers() {
      try {
        const response = await axios.get(`/api/v1/admin/groups/${this.$route.params.id}/manage-users/`);
        const groupUserIds = response.data.map(user => user.id);
        this.selectedUsers = groupUserIds; // Preselect users already in the group
      } catch (error) {
        this.errorMessage = 'Failed to fetch group users';
        setTimeout(() => {
          this.errorMessage = '';
        }, 3000);
      }
    },
    async submitUsers(action) {
      try {
        await axios.post(`/api/v1/admin/groups/${this.$route.params.id}/manage-users/`, {
          user_ids: this.selectedUsers,
          action: action
        });

        this.successMessage = action === 'add' ? 'Users added successfully' : 'Users removed successfully';
        setTimeout(() => {
          this.successMessage = '';
          this.$router.push('/groups');
        }, 2000);
      } catch (error) {
        this.errorMessage = 'Failed to update users in the group';
        setTimeout(() => {
          this.errorMessage = '';
        }, 3000);
      }
    }
  }
};
</script>
